import icon from '../assets/image/notification_Icon.png';
import sound from '../assets/sounds/notification.mp3';

export class NotificationChat {

    constructor(title, message, ref) {
        this.title = title;
        this.message = message;
        this.ref = ref;
    }

    show() {
        if (Notification.permission !== 'granted') {
            Notification.requestPermission().then((permission) => {
                if (permission === 'granted') {
                    this._display();
                } else {
                    // ('Permissão de notificação negada');
                    return;
                }
            });
        } else {
            this._display();
        }
    }

    _display() {
        if (document.hidden) {
            const notification = new Notification(
                this.title,
                {
                    body: this.message,
                    icon: icon,
                    requireInteraction: true,
                    lang: 'pt-BR',
                }
            );
            const audio = new Audio(sound);
            audio.play();
            notification.onclick = function () {
                window.focus();
            };
        }
        else {
            if (sessionStorage.getItem('@UCB-IdChat') !== this.ref) {
                const audio = new Audio(sound);
                audio.play();
            }
        }
    }
}